import React from 'react';
import PropTypes from 'prop-types';

import { uiConfig } from '../../../../../../../../../conf/valueSets';

// Components
import Table from '../../../../../../../../../../components/Table';
import { Spinner } from '../../../../../../../../../../components/Spinner';
import { ConstraintTypeModal } from './ConstraintTypeModal';

// Context
import { CriteriaStoreContext } from '../../../../../../../../state/criteria/context';

// Hooks
import { useGetValueSets } from '../../../../../../../../../../common/hooks/useGetValueSets';

// Utils
import { translateUIConfigForTable } from '../../../../../../../../../../common/utility';

export const ValueSetTableModal = (props) => {
    const { sessionToken } = React.useContext(CriteriaStoreContext);
    const { data, isLoading } = useGetValueSets({ sessionToken });
    const { columns, initialState } = translateUIConfigForTable(uiConfig);

    return (
        <ConstraintTypeModal header={'Value Sets'} id={'constraint-type-value-set-modal'} {...props}>
            {!isLoading ? (
                <Table
                    withHeader={true}
                    columns={columns}
                    data={data}
                    withActions={false}
                    rowClickAction={(rowData) => props?.onSelect?.(rowData)}
                    id={'value-set-manager'}
                    label={'Value Sets'}
                    showControlDeck={true}
                    paginated={true}
                    loading={isLoading}
                    initialState={initialState}
                />
            ) : (
                <Spinner size={'2.3rem'} color={'#7f7f7f'} style={{ margin: '0 auto' }} />
            )}
        </ConstraintTypeModal>
    );
};

ValueSetTableModal.propTypes = {
    closeDialog: PropTypes.func.isRequired,
    onSelect: PropTypes.func
};

export default ValueSetTableModal;
